module.exports = __webpack_public_path__ + "static/media/w_w_hr_25.0611bcdc.png";